import IUserGet from 'api/interfaces/users/IUserGet';
import api from './api';

export default {
  getCurrentUser: async (withoutTokenRefresh?: boolean): Promise<IUserGet[]> =>
    api.get('/api/v1/user', undefined, withoutTokenRefresh),
  updateLanguage: async (language: string | null): Promise<any> =>
    api.put('/api/v1/user/language', { language }),
  getAll: async (): Promise<IUserGet[]> => api.get('/api/v1/users'),
};
